import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { FetchRequestTypes, useFetch } from "../../../hooks/useFetch";
import _, { forEach } from "lodash";

export interface WeatherData {
  parameters: WeatherDataItem[];
  validTime: string;
}

export interface WeatherDataItem {
  level: number;
  levelType: string;
  name: string;
  unit: string;
  values: any[];
}

// For component use - maps short codes to short codes
export const WeatherPropertyCodes = {
  t: "t",
  msl: "msl",
  vis: "vis",
  wd: "wd",
  ws: "ws",
  gust: "gust",
  Wsymb2: "Wsymb2",
};

// Internal mapping for snow1g API transformation
const APIPropertyMapping = {
  t: "air_temperature",
  msl: "air_pressure_at_mean_sea_level",
  vis: "visibility_in_air",
  wd: "wind_from_direction",
  ws: "wind_speed",
  gust: "wind_speed_of_gust",
  Wsymb2: "symbol_code",
};

export const useWeatherData = (latLng: Number[] | null) => {
  const [url, setURL] = useState<string | null>(null);
  const { data, loading, error } = useFetch(url, FetchRequestTypes.GET);

  const [weatherDataItem, setWeatherDataItem] = useState<
    WeatherDataItem[] | null
  >(null);

  useEffect(() => {
    if (latLng?.length) {
      setURL(
        `/api-smhi/api/category/snow1g/version/1/geotype/point/lon/${latLng[1].toFixed(2)}/lat/${latLng[0].toFixed(
          2,
        )}/data.json`,
      );
    }
  }, [latLng]);

  useEffect(() => {
    if (data) {
      const today = data.timeSeries.filter((ts: WeatherData) => {
        const vt = dayjs(ts.validTime);
        const today = dayjs();
        const diff =
          vt.date() === today.date() && vt.hour() <= today.hour() + 1;

        return diff;
      });

      if (today.length > 0 && today[0].data) {
        const transformedProperties = Object.entries(APIPropertyMapping).map(
          ([shortCode, propertyName]) => {
            const value = (today[0].data as any)[propertyName];
            return {
              name: shortCode,
              values: [value],
              level: 0,
              levelType: "",
              unit: "",
            };
          },
        );

        setWeatherDataItem(transformedProperties);
      }
    }
  }, [data]);

  useEffect(() => {}, [loading, error]);

  return { weatherDataItem, loading, error };
};
